import React from 'react';
import { useTranslation } from 'react-i18next';
import c from 'classnames';
import Star from '../Star';
import s from './SaleIndicator.scss';
const SaleIndicator = ({ discount, size, background, withSparkles, className })=>{
    const { t } = useTranslation();
    return /*#__PURE__*/ React.createElement("span", {
        className: c(s['root'], size === 'small' && s['small'], background === 'themed' && s['themed'], background === 'black' && s['black'], className)
    }, t('buyCoreButton.sale', {
        sale: discount
    }), withSparkles && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Star, {
        className: s['star-one'],
        fill: background === 'themed' ? 'themed' : 'white'
    }), /*#__PURE__*/ React.createElement(Star, {
        className: s['star-two'],
        fill: background === 'themed' ? 'themed' : 'white'
    }), /*#__PURE__*/ React.createElement(Star, {
        className: s['star-three'],
        fill: background === 'themed' ? 'themed' : 'white'
    })));
};
SaleIndicator.displayName = 'SaleIndicator';
export default SaleIndicator;
